<template>
  <div class="container mx-auto">
    <el-dialog
      title="Nueva institución"
      :visible.sync="showNewInstitution"
      width="350px"
    >
      <el-form
        :model="newInstitutionForm"
        status-icon
        :rules="newInstitutionFormRules"
        ref="newInstitution"
        @submit.native.prevent="
          submitNewInstitution('newInstitution', newInstitutionForm)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de la institución" prop="name">
                  <el-input
                    placeholder="Nombre de la institución"
                    v-model="newInstitutionForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="País" prop="country">
                  <el-select
                    filterable
                    clearable
                    v-model="newInstitutionForm.country"
                    placeholder="Seleccionar departamento"
                    class="w-full"
                    size="small"
                  >
                    <el-option
                      v-for="c in countries"
                      :key="c.id"
                      :label="c.name"
                      :value="c.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewInstitution = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="Editar institución"
      :visible.sync="showEditInstitution"
      width="350px"
    >
      <el-form
        :model="editInstitutionForm"
        status-icon
        :rules="editInstitutionFormRules"
        ref="editInstitution"
        @submit.native.prevent="
          submitNewInstitution(
            'editInstitution',
            editInstitutionForm,
            editInstitutionForm.id
          )
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de la institución" prop="name">
                  <el-input
                    placeholder="Nombre de la institución"
                    v-model="editInstitutionForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="País" prop="country">
                  <el-select
                    filterable
                    clearable
                    v-model="editInstitutionForm.country"
                    placeholder="Seleccionar departamento"
                    class="w-full"
                    size="small"
                  >
                    <el-option
                      v-for="c in countries"
                      :key="c.id"
                      :label="c.name"
                      :value="c.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showEditInstitution = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="Nueva carrera"
      :visible.sync="showNewCareer"
      width="350px"
    >
      <el-form
        :model="newCareerForm"
        status-icon
        :rules="newCareerFormRules"
        ref="newCareer"
        @submit.native.prevent="submitNewCareer('newCareer', newCareerForm)"
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de la carrera" prop="name">
                  <el-input
                    placeholder="Nombre de la carrera"
                    v-model="newCareerForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewCareer = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="Editar carrera"
      :visible.sync="showEditCareer"
      width="350px"
    >
      <el-form
        :model="editCareerForm"
        status-icon
        :rules="editCareerFormRules"
        ref="editCareer"
        @submit.native.prevent="
          submitNewCareer('editCareer', editCareerForm, editCareerForm.id)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de la carrera" prop="name">
                  <el-input
                    placeholder="Nombre de la carrera"
                    v-model="editCareerForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showEditCareer = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-row :gutter="15" class="bg-white pb-5">
      <el-col :span="12">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">INSTITUCIONES</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Aquí se administran las diferentes instituciones que se utilizan en el sistema."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button
              type="primary"
              size="small"
              @click="openNewInstitutionDialog"
              >Nueva institución</el-button
            >
          </el-col>
          <el-col :span="10">
            <el-input
              placeholder="Buscar"
              v-model="searchInstitution"
              size="small"
              suffix-icon="el-icon-search"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-table :data="filteredInstitutions" stripe size="mini">
              <el-table-column type="index" width="40" />
              <el-table-column
                prop="name"
                label="Nombre de institución"
                min-width="300"
              />
              <el-table-column prop="name" label="País" min-width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.country.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Estado" min-width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.active">
                    <el-tag type="success" size="small">Activo</el-tag>
                  </span>
                  <span v-else>
                    <el-tag type="warning" size="small">Inactivo</el-tag>
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="60" align="center">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <el-button
                      icon="el-icon-fa-ellipsis-v"
                      size="small"
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        @click.native="openEditInstitutionDialog(scope.row)"
                      >
                        <i class="el-icon-fa-pencil"></i> Editar información
                      </el-dropdown-item>
                      <el-dropdown-item
                        @click.native="changeStatusInstitution(scope.row)"
                      >
                        <span v-if="scope.row.active">
                          <i class="el-icon-fa-times"></i> Desactivar
                        </span>
                        <span v-else>
                          <i class="el-icon-fa-check"></i> Activar
                        </span>
                        institución
                      </el-dropdown-item>
                      <el-dropdown-item
                        :divided="true"
                        class="text-red-500 font-semibold"
                        @click.native="deleteInstitution(scope.row)"
                      >
                        <i class="el-icon-fa-trash"></i> Eliminar
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChangeInstitution"
            :current-page.sync="pageInstitution.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="pageInstitution.size"
            layout="total, sizes, prev, pager, next"
            :total="rawInstitutions.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">CARRERAS</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Aquí se administran las diferentes carreras que se utilizan en el sistema."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button type="primary" size="small" @click="openNewCareerDialog"
              >Nueva carrera</el-button
            >
          </el-col>
          <el-col :span="10">
            <el-input
              placeholder="Buscar"
              v-model="searchCareer"
              size="small"
              suffix-icon="el-icon-search"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-table :data="filteredCareers" stripe size="mini">
              <el-table-column type="index" width="40" />
              <el-table-column prop="name" label="Posición" min-width="200" />
              <el-table-column label="Estado" min-width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.active">
                    <el-tag type="success" size="small">Activo</el-tag>
                  </span>
                  <span v-else>
                    <el-tag type="warning" size="small">Inactivo</el-tag>
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="60" align="center">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <el-button
                      icon="el-icon-fa-ellipsis-v"
                      size="small"
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        @click.native="openEditCareerDialog(scope.row)"
                      >
                        <i class="el-icon-fa-pencil"></i> Editar información
                      </el-dropdown-item>
                      <el-dropdown-item
                        @click.native="changeStatusCareer(scope.row)"
                      >
                        <span v-if="scope.row.active">
                          <i class="el-icon-fa-times"></i> Desactivar
                        </span>
                        <span v-else>
                          <i class="el-icon-fa-check"></i> Activar
                        </span>
                        carrera
                      </el-dropdown-item>
                      <el-dropdown-item
                        :divided="true"
                        class="text-red-500 font-semibold"
                        @click.native="deleteCareer(scope.row)"
                      >
                        <i class="el-icon-fa-trash"></i> Eliminar
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChangeCareer"
            :current-page.sync="pageCareer.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="pageCareer.size"
            layout="total, sizes, prev, pager, next"
            :total="rawCareers.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import * as V from "voca";

export default {
  name: "SettingsInstitutionsStudies",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{ 
          institutions { id name active country { name } }
          careers { id name active }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.institutions, data.careers));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      rawInstitutions: [],
      rawCareers: [],
      searchInstitution: "",
      searchCareer: "",
      pageInstitution: {
        size: 5,
        number: 1,
      },
      pageCareer: {
        size: 5,
        number: 1,
      },
      showNewInstitution: false,
      showNewCareer: false,
      newInstitutionForm: {
        name: "",
        country: null,
      },
      newCareerForm: {
        name: "",
      },
      newInstitutionFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Por favor selecciona el país.",
            trigger: "change",
          },
        ],
      },
      newCareerFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
      },
      showEditInstitution: false,
      showEditCareer: false,
      editInstitutionForm: {
        name: "",
        country: null,
      },
      editCareerForm: {
        name: "",
      },
      editInstitutionFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Por favor selecciona el país.",
            trigger: "change",
          },
        ],
      },
      editCareerFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
      },
      countries: [],
    };
  },
  methods: {
    setData(dataInstitution, dataCareer) {
      this.rawInstitutions = dataInstitution;
      this.rawCareers = dataCareer;
    },
    handleSizeChangeInstitution(val) {
      this.pageInstitution.size = val;
    },
    handleSizeChangeCareer(val) {
      this.pageCareer.size = val;
    },
    changeStatusInstitution(institution) {
      const action = institution.active ? "desactivar" : "activar";
      const message = `¿Estás seguro que deseas ${action} esta institución?`;
      const saveText = `Si, ${V.titleCase(action)}`;
      this.$confirm(message, "Confirmación", {
        confirmButtonText: saveText,
        cancelButtonText: "Cancelar",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Procesando...";
            axios
              .post("/", {
                query: `
                mutation { 
                  institutionUpdateStatus
                  ( where: { id: ${
                    institution.id
                  } } active: ${!institution.active} )
                  { id name active country { name } }
                }`,
              })
              .then((res) => {
                const { data, errors } = res.data;
                if (R.isNil(errors)) {
                  this.rawInstitutions = data.institutionUpdateStatus;
                }
                this.$notify({
                  title: R.isNil(errors) ? "Éxito" : "Error",
                  message: R.isNil(errors)
                    ? "Se ha cambiado el estado correctamente"
                    : errors[0].message,
                  type: R.isNil(errors) ? "success" : "error",
                  duration: 3500,
                });
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = saveText;
                done();
              });
          } else {
            done();
          }
        },
      });
    },
    changeStatusCareer(career) {
      const action = career.active ? "desactivar" : "activar";
      const message = `¿Estás seguro que deseas ${action} esta carrera?`;
      const saveText = `Si, ${V.titleCase(action)}`;
      this.$confirm(message, "Confirmación", {
        confirmButtonText: saveText,
        cancelButtonText: "Cancelar",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Procesando...";
            axios
              .post("/", {
                query: `
                mutation { 
                  careerUpdateStatus
                  ( where: { id: ${career.id} } active: ${!career.active} )
                  { id name active }
                }`,
              })
              .then((res) => {
                const { data, errors } = res.data;
                if (R.isNil(errors)) {
                  this.rawCareers = data.careerUpdateStatus;
                }
                this.$notify({
                  title: R.isNil(errors) ? "Éxito" : "Error",
                  message: R.isNil(errors)
                    ? "Se ha actualizado la carrera correctamente"
                    : errors[0].message,
                  type: R.isNil(errors) ? "success" : "error",
                  duration: 3500,
                });
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = saveText;
                done();
              });
          } else {
            done();
          }
        },
      });
    },
    deleteInstitution({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar esta institución?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { institutionDelete( where: {id: ${id}} ) { id name active country { name } } }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawInstitutions = data.institutionDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado esta institución correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    deleteCareer({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar esta carrera?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { careerDelete( where: {id: ${id}} ) { id name active } }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawCareers = data.careerDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado esta carrera correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    openNewInstitutionDialog() {
      const ref = this.$refs["newInstitution"];
      if (!R.isNil(ref)) {
        ref.resetFields();
      }
      axios
        .post("/", {
          query: `{ countries { id name } }`,
        })
        .then((res) => {
          const { data } = res.data;
          if (!R.isNil(data)) {
            this.countries = data.countries;
          }
          this.showNewInstitution = true;
        });
    },
    openNewCareerDialog() {
      const ref = this.$refs["newCareer"];
      if (!R.isNil(ref)) {
        ref.resetFields();
      }
      this.showNewCareer = true;
    },
    openEditInstitutionDialog({ id }) {
      axios
        .post("/", {
          query: `
          { 
            institution(where: { id: ${id} }) { id name active country { id } }
            countries { id name }
          }
          `,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            const country = data.institution.country.id;
            this.editInstitutionForm = { ...data.institution, country };
            this.countries = data.countries;
          }
          const ref = this.$refs["editInstitution"];
          if (!R.isNil(ref)) {
            ref.resetFields();
          }
          this.showEditInstitution = true;
        });
    },
    openEditCareerDialog({ id }) {
      axios
        .post("/", {
          query: `
          { 
            career(where: { id: ${id} }) { id name active }
          }
          `,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.editCareerForm = { ...data.career };
          }
          const ref = this.$refs["editCareer"];
          if (!R.isNil(ref)) {
            ref.resetFields();
          }
          this.showEditCareer = true;
        });
    },
    submitNewInstitution(formName, { name, country }, institutionId = false) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        const action = institutionId ? "editar" : "crear";
        const mutation = institutionId
          ? `institutionEdit(data: { name: "${name}" country: ${country}} where: { id: ${institutionId} } )`
          : `institutionCreate(data: { name: "${name}" country: ${country}} )`;
        this.$confirm(
          `¿Estás seguro que deseas ${action} esta institución?`,
          "Confirmación",
          {
            confirmButtonText: `Si, ${action}`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { 
                      ${mutation}
                      { id name active country { name } }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawInstitutions = institutionId
                        ? data.institutionEdit
                        : data.institutionCreate;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se ha creado la institución correctamente`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showNewInstitution = false;
                    this.showEditInstitution = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, ${action}`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    submitNewCareer(formName, { name }, careerId = false) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        const action = careerId ? "editar" : "crear";
        const mutation = careerId
          ? `careerEdit(data: { name: "${name}" } where: { id: ${careerId} } )`
          : `careerCreate(data: { name: "${name}" } )`;
        this.$confirm(
          `¿Estás seguro que deseas ${action} esta carrera?`,
          "Confirmación",
          {
            confirmButtonText: `Si, ${action}`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { 
                      ${mutation}
                      { id name active }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawCareers = careerId
                        ? data.careerEdit
                        : data.careerCreate;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se ha creado la carrera correctamente`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showNewCareer = false;
                    this.showEditCareer = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, ${action}`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
  },
  computed: {
    filteredInstitutions() {
      return this.rawInstitutions
        .filter((institution) => {
          return (
            institution.name
              .toLowerCase()
              .includes(this.searchInstitution.toLowerCase()) ||
            institution.country.name
              .toLowerCase()
              .includes(this.searchInstitution.toLowerCase())
          );
        })
        .slice(
          this.pageInstitution.number * this.pageInstitution.size -
            this.pageInstitution.size,
          this.pageInstitution.size * this.pageInstitution.number
        );
    },
    filteredCareers() {
      return this.rawCareers
        .filter((position) => {
          return position.name
            .toLowerCase()
            .includes(this.searchCareer.toLowerCase());
        })
        .slice(
          this.pageCareer.number * this.pageCareer.size - this.pageCareer.size,
          this.pageCareer.size * this.pageCareer.number
        );
    },
  },
};
</script>

<style></style>
